export function apiPost<TRequest, TResponse>(url: string, data: TRequest): Promise<TResponse> {
    return fetch(url, {
        method: 'POST',
        credentials: 'include', 
        headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest', 
        },
        body: JSON.stringify(data),
    })
        .then(response => {
            if (!response.ok) {
                return response.text().then(text => { throw new Error(text) });
            }
            return response.json() as Promise<TResponse>;
        })
        .catch(error => {
            throw error;
        });
}
